import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../components/CustomComponent.js";
import ThaiBahtText from "thai-baht-text";
export default class PaymentHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      document_no: "",
      created_at: "",
      customer_name: "",
      customer_phone: "",
      customer_address: "",
      customer_tax: "",
      amount: "0.00",
      amount_deposit: "0.00",
      total_pay: "0.00",
      transaction_list: [],
    };
  }

  async componentDidMount() {
    loading(false);
    if (params("uid")) {
      await this.Get(params("uid"));
    }
    window.print();
  }
  Get = async (uid) => {
    loading(true);
    let result = await GET("admin/invoices/list", { uid });
    if (result?.status) {
      const item = result.data;
      if (item.sale) {
        this.setState({
          document_no: item.document_no,
          created_at: item.created_at,
          customer_name:
            item.sale?.customer_name || item.sale?.customer?.full_name || "-",
          customer_phone:
            item.sale?.customer_phone || item.sale?.customer?.phone || "-",
          customer_address:
            item.sale?.customer_address || item.sale?.customer?.address || "-",
          customer_tax: item.sale?.customer?.tax_number || "-",
          transaction_list: item.sale?.transaction_list || [],
          amount: item.sale?.amount,
          amount_deposit: item.sale?.amount_deposit,
          total_pay: item.sale?.total_pay,
        });
      } else if (item.repair) {
        this.setState({
          document_no: item.document_no,
          created_at: item.created_at,
          customer_name:
            item.repair?.customer_name ||
            item.repair?.customer?.full_name ||
            "-",
          customer_phone:
            item.repair?.customer_phone || item.repair?.customer?.phone || "-",
          customer_address:
            item.repair?.customer_address ||
            item.repair?.customer?.address ||
            "-",
          customer_tax: item.repair?.customer?.tax_number || "-",
          transaction_list:
            item.repair?.stock_activity_list
              .map((e) => e.transaction_list)
              .flat() || [],
          amount: item.repair?.amount,
          amount_deposit: item.repair?.amount_deposit,
          total_pay: item.repair?.total_pay,
        });
      }
    }
    loading(false);
  };
  render() {
    const {
      document_no,
      created_at,
      customer_name,
      customer_phone,
      customer_address,
      customer_tax,
      transaction_list,
      amount,
      amount_deposit,
      total_pay,
    } = this.state;
    return (
      <div
        className="mx-auto bg-white p-5 pdf"
        style={{ width: 1116, height: 1579 }}
      >
        <h1 className="fw-bold text-center mb-3">
          ห.จ.ก. เชียงใหม่เซียงกงอะไหล่ยนต์ (2000) สำนักงานใหญ่
        </h1>
        <h4 className="fw-bold text-center mb-3">
          61 ถ.ซุปเปอร์ไฮเวย์ เชียงใหม่ - ลำปาง ต.ช้างเผือก อ.เมืองเชียงใหม่
          จ.เชียงใหม่
        </h4>
        <h5 className="fw-bold text-center mb-3">
          โทร. (053) 211747, 213301, 215323 แฟกซ์ (053) 210060
        </h5>
        <h5 className="fw-bold text-center mb-4">
          ทะเบียนการค้าเลขที่ ช.ม. 7820 เลขที่ประจำตัวผู้เสียภาษี 0503543004277
        </h5>
        <h2 className="fw-bold text-center mb-4">ใบส่งของ</h2>
        <div className="d-flex justify-content-between mb-3">
          <div>
            <h5 className="fw-bold mb-3">เลขที่เอกสาร : {document_no}</h5>
            <h5 className="fw-bold mb-3">
              วันที่ : {format_date(created_at, "dd mmmm yyyy", "th")}
            </h5>
            <h5 className="fw-bold mb-3">ชื่อผู้ซื้อ : {customer_name}</h5>
            <h5 className="fw-bold mb-3">
              เลขที่ประจำตัวผู้เสียภาษี : {customer_tax}
            </h5>
            <h5 className="fw-bold mb-3">ที่อยู่ : {customer_address}</h5>
          </div>
          <div>
            <div className="d-flex">
              <input type="checkbox" className="me-3" />
              <h5 className="fw-bold me-3">สำนักงานใหญ่</h5>
              <input type="checkbox" className="me-3" />
              <h5 className="fw-bold me-3">
                สาขา...........................................
              </h5>
            </div>
          </div>
        </div>
        <table className="table table-bordered mb-4 text-18">
          <thead>
            <tr className="border-0">
              <td className="fw-bold text-center border-1 wpx-70" rowSpan={2}>
                ลำดับที่
              </td>
              <td className="fw-bold text-center border-1" rowSpan={2}>
                รายการสินค้าหรือบริการ
              </td>
              <td className="fw-bold text-center border-1 wpx-100" rowSpan={2}>
                จำนวนหน่วย
              </td>
              <td className="fw-bold text-center border-1" colSpan={2}>
                ราคาต่อหน่วย
              </td>
              <td className="fw-bold text-center border-1" colSpan={2}>
                มูลค่าสินค้าหรือบริการ
              </td>
            </tr>
            <tr className="border-0">
              <td className="fw-bold text-center border-1">บาท</td>
              <td className="fw-bold text-center border-1 wpx-40">สต.</td>
              <td className="fw-bold text-center border-1">บาท</td>
              <td className="fw-bold text-center border-1 wpx-40">สต.</td>
            </tr>
          </thead>
          <tbody>
            {transaction_list.map((item, index) => (
              <tr className="border-0">
                <td className="text-center" style={{ border: "0px 1px" }}>
                  {index + 1}
                </td>
                <td className="text-start" style={{ border: "0px 1px" }}>
                  {item.product_code} {item.product_name}
                </td>
                <td className="text-center" style={{ border: "0px 1px" }}>
                  {item.qty} {item.unit_name}
                </td>
                <td className="text-end" style={{ border: "0px 1px" }}>
                  {toFixed(Number(item.unit_price)).split(".")[0]}
                </td>
                <td className="text-end" style={{ border: "0px 1px" }}>
                  {toFixed(Number(item.unit_price)).split(".")[1]}
                </td>
                <td className="text-end" style={{ border: "0px 1px" }}>
                  {
                    toFixed(Number(item.unit_price) * Number(item.qty)).split(
                      "."
                    )[0]
                  }
                </td>
                <td className="text-end" style={{ border: "0px 1px" }}>
                  {
                    toFixed(Number(item.unit_price) * Number(item.qty)).split(
                      "."
                    )[1]
                  }
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="border-0">
              <td
                className="fw-bold text-end"
                style={{ border: 0, borderTop: "1px solid #000" }}
                colSpan={5}
              >
                รวมมูลค่าสินค้าหรือบริการ
              </td>
              <td className="text-end border-1">
                {(() => {
                  let _total = 0;
                  for (let item of transaction_list) {
                    _total += Number(item.unit_price) * Number(item.qty);
                  }
                  return toFixed(Number(_total)).split(".")[0];
                })()}
              </td>
              <td className="text-end border-1">
                {(() => {
                  let _total = 0;
                  for (let item of transaction_list) {
                    _total += Number(item.unit_price) * Number(item.qty);
                  }
                  return toFixed(Number(_total)).split(".")[1];
                })()}
              </td>
            </tr>
            <tr className="border-0">
              <td className="fw-bold text-end border-0" colSpan={5}>
                จำนวนเงินรวมทั้งสิ้น
              </td>
              <td className="text-end border-1">
                {(() => {
                  let _total = 0;
                  for (let item of transaction_list) {
                    _total += Number(item.unit_price) * Number(item.qty);
                  }
                  return toFixed(Number(_total)).split(".")[0];
                })()}
              </td>
              <td className="text-end border-1">
               {(() => {
                  let _total = 0;
                  for (let item of transaction_list) {
                    _total += Number(item.unit_price) * Number(item.qty);
                  }
                  return toFixed(Number(_total)).split(".")[1];
                })()}
              </td>
            </tr>
          </tfoot>
        </table>
        <h5 className="fw-bold mb-3">จำนวนเงินรวมทั้งสิ้น (ตัวอักษร)</h5>
        <div className="border-1 border-dark py-3 px-4 mb-5 w-100">
          <h5 className="fw-bold mb-0">{ThaiBahtText(Number(amount)) || "ศูนย์บาทถ้วน"}</h5>
        </div>
        <div className="d-flex justify-content-around text-center pt-5">
          <div>
            <h5 className="fw-bold mb-4">
              ลงชื่อ.....................................................................................ผู้รับสินค้า
            </h5>
            <h5 className="fw-bold mb-4 me-5">
              (..........................................................................................)
            </h5>
            <h5 className="fw-bold mb-4">
              วันที่.................................................................................................
            </h5>
          </div>
          <div>
            <h5 className="fw-bold mb-4">
              ลงชื่อ.....................................................................................ผู้รับเงิน
            </h5>
            <h5 className="fw-bold mb-4 me-4">
              (..........................................................................................)
            </h5>
            <h5 className="fw-bold mb-4">
              วันที่.................................................................................................
            </h5>
          </div>
        </div>
      </div>
    );
  }
}
